module.exports = __webpack_public_path__ + "public/SiteIcons/heartIconOn.svg?190bb297";